import { __awaiter } from "tslib";
import Vue from 'vue';
import { mapGetters } from 'vuex';
import SERVICE_CONSTANTS from '@/constants/services';
export default Vue.extend({
    name: 'TerminalPromo',
    data: () => ({
        isVisible: false,
        terminalDownloadUrl: '',
        terminalPageUrl: SERVICE_CONSTANTS.NEW_BINANCE + '/download-terminal'
    }),
    computed: Object.assign(Object.assign(Object.assign({}, mapGetters('notifications', ['getAll'])), mapGetters('user', ['getUserData'])), { terminalNotification() {
            return this.getAll.find((notification) => notification.slug === 'terminal-promo-1-widebar');
        } }),
    methods: {
        handleDownload() {
            if (this.terminalNotification) {
                this.$store.dispatch('notifications/read', this.terminalNotification.id);
            }
            window.ym(98011557, 'reachGoal', 'Terminal_download_api_key', { userId: this.getUserData.uuid });
        }
    },
    beforeMount() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const menuDataPromise = this.services.v2.widgets.getUserMenuData();
                const linkResponse = yield this.services.v2.widgets.getTerminalDownloadData();
                if (linkResponse.status !== 200 || !linkResponse.data.payload.downloadLink) {
                    return;
                }
                this.terminalDownloadUrl = linkResponse.data.payload.downloadLink;
                const response = yield menuDataPromise;
                if (response.status === 200) {
                    this.isVisible = response.data.payload.menu.terminal.state === 'visible';
                }
            }
            catch (e) {
                console.error(e);
            }
        });
    }
});
